import useExperiences from 'hooks/Experiences/useExperiences'
import React from 'react'
import { ExperienceItem } from 'tripPlanner/types/tripItem'
import LEExperienceSummaryCard from './LEExperienceSummaryCard'

interface Props {
  item: ExperienceItem
  experienceId: string
  cardRef: React.RefObject<HTMLDivElement>
  onClose: () => void
}

function SavedLEExperienceSummaryCard({ item, experienceId, cardRef, onClose }: Props) {
  const [[experience], isLoading] = useExperiences([experienceId])

  if (isLoading || !experience) {
    return null
  }

  return <LEExperienceSummaryCard experience={experience} tripItem={item} cardRef={cardRef} onClose={onClose} />
}

export default SavedLEExperienceSummaryCard
